<template lang="pug">
#plan(v-cloak)
  .box
    .box-header
      .d-flex.justify-content-start.align-items-center
        .d-flex.justify-content-start.flex-column
          .title
            span 契約プラン
    .box-body
      b-tabs(v-model="tabIndex")
        // family service tab
        b-tab.tab(title="家族連絡")
          FamilyServicePlanTab(ref="familyServicePlanTab")
        // waiter service tab
        b-tab.tab(title="入所者募集管理")
          WaiterServicePlanTab(ref="waiterServicePlanTab")
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import FamilyServicePlanTab from "@/pc/containers/settings/FamilyServicePlanTab.vue";
import WaiterServicePlanTab from "@/pc/containers/settings/WaiterServicePlanTab.vue";

/**
 * ### プラン確認・変更画面コンポーネント
 */
@Component({
  components: {
    FamilyServicePlanTab,
    WaiterServicePlanTab
  }
})
export default class PlanList extends Vue {
  /** 現在表示しているタブ番号 */
  tabIndex: number = 0;

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    return;
  }
}
</script>

<style lang="scss" scoped>
#plan {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;

  .box-header {
    .title {
      font-size: 22px;
      font-weight: bold;
    }
  }
}
</style>
